const specialEngagementPrefix = "/api/v1/special-engagement";
const giftCatalogPrefix = "/api/v1/merchandise/gift";
const crmPointPrefix = "/api/v1/crm-points";

export const routes = {
  SUBS_DIARIES: {
    GETSTATE: "/api/v1/warranty/state-city/get-state",
    GETCITY: "/api/v1/warranty/state-city/get-state-city",
    ADD_SUBSDIRES: "/api/v1/user/add-subsidiaries",
    GET_SUBSDIRES: "/api/v1/user/get-subsidiaries",
    DELETE_SUBSDIRES: "/api/v1/user/delete-subsidiaries",
    EDIT_SUBSDIRES: "/api/v1/user/edit-subsidiaries"
  },
  USER: {
    GET_USER_INFO: "/api/v1/user/get-user-info-baadshah",
    UPDATE_USER_INFO: "/api/v1/user/update-user-baadshah",
    UPLOAD_PROFILE_IMAGE: "/api/v1/user/upload-profile-image",
    UPDATE_DETAIL_REQUEST: "/api/v1/user/send-mail",
    CHANGE_PASSWORD: "/api/v1/user/change-password",
    SEARCH_FLEET: "/api/v1/user/baadshah/search-fleet",
    SEARCH_DEALER: "/api/v1/user/search-dealer",
  },
  AUTH: {
    FORGOT_PASSWORD: "/api/v1/user/forgot-password",
    LOGIN: "/api/v1/auth/login",
    LOGOUT: "/api/v1/user/logout-from-all",
    INVITE_SEND_OTP: "/api/v2/warranty/secondary-points/invite-send-otp",
    SEND_OTP: "/api/v1/auth/send-otp"
  },
  DASHBOARD: {
    SECONDARY_COUNT: "/api/v1/warranty/secondary-points/dashboard-count",
    PRIMARY_POINTS: "/api/v1/crm-points/dashboard/points",
    YEARLY_OFFTAKE: "/api/v1/crm-points/dashboard/offtake/yearly",
    PRIMARY_GRAPH: "/api/v1/crm-points/dashboard/plot-graph",
    YTD: "/api/v1/crm-points/dashboard/year-till-date",
    MTD: "/api/v1/crm-points/dashboard/month-till-date",
    QTD: "/api/v1/crm-points/dashboard/quarter-till-date",
    GET_REDEEM_DATA: "/api/v1/user/get-redeem-data",
    VIDEO_URL: "/api/v1/user/video-url",
    GET_REPORT_ALL: "/api/v2/crm-points/baadshah/reports/all",
    GET_POINTS: "/api/v1/crm-points/baadshah/reports/points",
    OFFTAKE_VERIFICATION_COUNT: "/api/v1/offtake/offtake-verification-count",
    DOWNLOAD_SCORE_CARD: "/api/v1/crm-points/baadshah/download-excel",
    HO_DOWNLOAD_SCORE_CARD: "/api/v1/crm-points/baadshah/download-excel-ho",
    DOWNLOAD_FLEET_REPORT_SIDENAV: "/api/v1/fleet-register/download-report",
    NAVBAR_TOHIDE: "/api/v1/user/inactive-menu",
    FILTERAPI: "/api/v1/sales-report/filter-api",
    GET_DISPLAY_LABEL: "/api/v1/crm-points/get-display-label",
    GET_OFFTAKE_SUMMARY: "/api/v1/crm-points/baadshah/reports/offtake",
    GET_CLUB_NAME: "/api/v1/user/get-baadshah-user-club-data",
    GET_REDEEMPTION_DASHBOARD: "/api/v1/crm-points/order/get-redeemption-dashboard",
  },
  HODASHBOARD: {
    GETOFFTAKESALESENTRY: "/api/v1/crm-points/baadshah/get-offtake-sales-entry",
    FILTERAPI: "/api/v1/sales-report/filter-api",
    GETDIRECTINDIRECTDATA:
      "/api/v1/crm-points/baadshah/get-direct-indirect-data",
    GETFLEETSTATUSCOUNT: "/api/v1/crm-points/baadshah/get-fleet-status-count",
    DOWNLOAD_FLEET_REPORT:
      "/api/v1/crm-points/baadshah/get-fleet-status-report",
    DOWNLOAD_SALES_REPORT:
      "/api/v1/crm-points/baadshah/get-offtake-sales-report-download",
    DOWNLOAD_VERIFIED_SALES: "/api/v1/crm-points/baadshah/download-verified-sales",
    SALES_TARGET_ACIVEMENT: "/api/v1/crm-points/baadshah/get-offtake-sales-achievement"
  },
  FLEET_REGISTRATION: {
    GET_VEHICALE_TYPE: "/api/v2/fleet/get-vehicle-type",
    GET_VEHICALE_MAKE: "/api/v1/fleet/vehicle/get-vehicle-type-brand",
    GET_FLEET_DATA: "/api/v2/fleet/fleet-data",
    POST_FLEET_DATA: "/api/v2/fleet/fleet-data",
    DELETE_FLEET: "/api/v2/fleet/fleet-data",
    UPDATE_FLEET: "/api/v2/fleet/fleet-data",
    GET_BUSINESS_RELATED_DETAILS: "/api/v2/fleet/get-business-related-detail",
    UPDATE_BUSINESS_RELATED_DETAIL:
      "/api/v2/fleet/update-business-related-detail",
    UPDATE_BAADSHAH_PROFILE_CATEGORY: '/api/v2/fleet/update-baadshah-profile-category'
  },
  OFFTAKE_ENTRY: {
    GET_DEALER_NAME: "/api/v1/offtake/get-dealer-name",
    GET_OFFTAKE_BY_ID_OLD: "/api/v1/offtake/get-offtake-entry-by-id",
    GET_OFFTAKE_BY_ID: "/api/v2/offtake/get-offtake-entry-by-id",
    GET_OFFTAKE_ENTRY: "/api/v1/offtake/get-offtake-entry",
    ADD_OFFTAKE_ENTRY: "/api/v1/offtake/add-offtake-entry",
    UPDATE_OFFTAKE_ENRY: "/api/v1/offtake/fleet-manager/edit-offtake-entry",
    GET_SUBSIDAIRY: "/api/v1/user/get-subsidiaries",
    UPLOAD_INVOICE: "/api/v1/offtake/upload-invoice",
    GET_VEHICLE_SKU_ID: "/api/v1/warranty/vehicle/get-vehicle-sku-id",
    GET_OFFTAKE_ENTRIES_COUNT: "/api/v1/offtake/offtake-verification-count"
  },
  FLEET_MANAGER: {
    GET_REJECT_REMARK: "/api/v1/offtake/fleet-manager/get-reject-remark",
    GET_PENDING_OFFTAKE: "/api/v1/offtake/fleet-manager/get-offtake",
    VERIFY_OFFTAKE: "/api/v1/offtake/fleet-manager/verify-offtake",
    INDIRECT_BILLING_REPORT: "/api/v1/offtake/fleet-manager/billing-report",
    INDIRECT_BILLING_REPORT_BY_MONTH:
      "/api/v1/offtake/fleet-manager/billing-report-bymonth",
    OFFTAKE_VERIFICATION_COUNT:
      "/api/v1/offtake/fleet-manager/offtake-verification-count",
    OFFTAKE_SCORE_CARD_FLEET:
      "/api/v1/crm-points/baadshah/offtake-score-card-fleet",
    GET_TOTAL_VEHICLES_TYRES:
      "/api/v1/offtake/fleet-manager/total-vehicle-and-tyre",
    GET_TOTAL_VEHICLES_TYRES_BY_FLEET:
      "/api/v1/offtake/fleet-manager/total-vehicle-and-tyre-by-fleet",
    GET_FLEET_PROFILE_DETAIL: "/api/v1/user/get-user-info-baadshah",
    GET_SUBSIDIARIES: "/api/v1/user/get-subsidiaries"
  },
  PRIMARY_REPORT: {
    GET_DELEAR_REPORT_QUARTERLY: "/api/v1/crm-points/reports/all",
    OFFTAKE_SUMMARY: "/api/v1/crm-points/baadshah/reports/offtake",
  },
  ABOUT_DETAIL: {
    GET_ABOUT_DETAIL: "/api/v1/crm-points/about"
  },
  SALES_REPORT: {
    ADD_DEFAULT_FLEET_SALES: "/api/v1/sales-report/add-default-fleet-sales",
    GET_FLEET_SALES: "/api/v1/sales-report/get-fleet-sales",
    GET_TOTAL_FLEET_SALES: "/api/v1/sales-report/get-total-fleet-sales",
    GET_FLEET: "/api/v1/sales-report/get-fleet",
    GET_SKU: "/api/v1/sales-report/get-sku",
    SAVE_SALE: "/api/v1/sales-report/add-sales",
    GET_ZONAL_FLEET_MANAGER_SALES_REPORT:
      "/api/v1/sales-report/get-zonal-fleet-manager-sales-report",
    GET_FLEET_SALES_TOTAL_REPORT:
      "/api/v1/sales-report/get-fleet-sales-total-report",
    GET_FLEET_SALES_REPORT: "/api/v1/sales-report/get-fleet-sales-report",
    GET_TARGET_SALES: "/api/v1/sales-report/get-target-sales-of-month",
    UPDATE_TARGET_SALES: "/api/v1/sales-report/update-target-sales-of-month",
    DELETE_SALES: "/api/v1/sales-report/delete-sales",
    EDIT_SALES: "/api/v1/sales-report/edit-sales",
    GET_SALES: "/api/v1/sales-report/get-sales"
  },
  OTHER: {
    SAVE_TOKEN: "/api/v1/message/save-token",
    GET_UNREAD_NOTIFICATION_COUNT:
      "/api/v1/message/get-unread-notification-count",
    GET_NOTIFICATION: "/api/v1/message/get-notification"
  },
  NEW_FLEET: {
    ADD_INVITE_FLEET: "/api/v1/fleet-register/add-invited-fleet",
    EDIT_INVITE_FLEET: "/api/v1/fleet-register/edit-invited-fleet",
    GET_SM_AND_SM: "/api/v1/fleet-register/get-asm-and-sm",
    UPLOAD_FLEET_DOC: "/api/v1/fleet-register/upload-fleet-doc",
    GET_NEW_FLEET: "/api/v1/fleet-register/get-invited-fleet",
    GET_NEW_FLEET_BY_ID: "/api/v1/fleet-register/get-invited-fleet-by-id",
    GET_DEPOT: "/api/v1/fleet-register/get-depot",
    ADD_SUBSDIRES: "/api/v1/fleet-register/add-subsidiaries",
    EDIT_SUBSDIRES: "/api/v1/fleet-register/edit-subsidiaries",
    GET_FLEET_DATA: "/api/v1/fleet-register/fleet-data",
    GET_SUBSDIRES: "/api/v1/fleet-register/get-subsidiaries",
    DELETE_SUBSDIRES: "/api/v1/fleet-register/delete-subsidiaries",
    POST_FLEET_DATA: "/api/v1/fleet-register/fleet-data",
    INVITE_FLEET_NUMBER: "/api/v1/fleet-register/invited-fleet-with-number",
    VERIFY_INVITE_FLEET: "/api/v1/fleet-register/verify-invited-fleet",
    VERIFY_OTP: "/api/v2/warranty/secondary-points/verify-otp",
    GET_INVITED_FLEET_BY_NUMBER:
      "/api/v1/fleet-register/get-invited-fleet-by-number",
    GET_BRAND: "/api/v1/cip-register/get-brand",
    GET_BRAND_PATTERN: "/api/v1/cip-register/get-brand-pattern",
    UPDATE_PROSPECTIVE_FLEET:
      "/api/v1/fleet-register/update-prospective-fleet-status",
    EDIT_BUSINESS_RELATED_DETAIL:
      "/api/v1/fleet-register/edit-business-related-detail",
    SAP_ID_EXITS: "/api/v1/fleet-register/sap-id-exists",
    GET_BUSINESS_RELATED_DETAIL:
      "/api/v1/fleet-register/get-business-related-detail",
    UPDATE_BUSINESS_RELATED_DETAIL:
      "/api/v1/fleet-register/update-business-related-detail"
  },
  ACTIVITY_REPORT: {
    GET_ACTIVITY_LIST: "/api/v1/activity-report/get-activity-list",
    ADD_ACTIVITY: "/api/v1/activity-report/add-activity",
    EDIT_ACTIVITY: "/api/v1/activity-report/edit-activity",
    GET_ACTIVITY: "/api/v1/activity-report/get-activity",
    GET_TOTAL_ACTIVITY_COUNT:
      "/api/v1/activity-report/get-total-activity-count",
    UPDATE_ACTIVITY_TARGET:
      "/api/v1/activity-report/update-target-activity-of-month",
    GET_ACTIVITY_TARGET: "/api/v1/activity-report/get-target-activity-of-month",
    GET_ACTIVITY_REPORT_ZFM:
      "/api/v1/activity-report/get-fm-achievement-report",
    GET_TOTAL_ACTIVITY_COUNT_REPORT_ZFM:
      "/api/v1/activity-report/get-total-fm-achievement-report",
    DELETE_ACTIVITY: "/api/v1/activity-report/delete-activity",
    GET_BRAND: "/api/v1/cip-register/get-brand",
    GET_BRAND_PATTERN: "/api/v1/cip-register/get-brand-pattern",
  },
  SPECIAL_ENGAGEMENT: {
    ADD_POPUP_DATA: `${specialEngagementPrefix}/add-popup-data`,
    GET_POPUP_DETAIL: `${specialEngagementPrefix}/get-popup-detail`,
    SUBMIT_POPUP_DETAIL: `${specialEngagementPrefix}/submit-popup-detail`,
    GET_POPUP_LINK: `${specialEngagementPrefix}/get-popup-link`,
    GET_USER_POPUP_TITLES: `${specialEngagementPrefix}/get-user-popup-titles`,
    GET_USER_POPUP_DETAIL: `${specialEngagementPrefix}/get-user-popup-detail`
  },
  FLEET_DETAIL: {
    FLEET_DETAILS_CARD: '/api/v1/fleet-register/fleet-details-cards',
    GET_FLEET_DETAIL: '/api/v1/fleet-register/fleet-details'
  },
  GIFT_CATALOG: {
    GET_GIFT_FILTER_DETAILS: `${giftCatalogPrefix}/get-gift-filter-detail`,
    GET_GIFT_ITEMS: `${giftCatalogPrefix}/get-gift-item-list`,
    GET_GIFT_ITEM_DETAIL: `${giftCatalogPrefix}/get-gift-item-detail`,
    GET_PRODUCT_LIST: `${giftCatalogPrefix}/get-product-list`,
    UPLOAD_PRODUCT_IMAGE: `${giftCatalogPrefix}/upload-product-image`,
    UPDATE_DEFAULT_IMAGE: `${giftCatalogPrefix}/update-default-image`,
    UPLOAD_GIFT_ITEMS: `${giftCatalogPrefix}/upload-gift-items`,
    UPDATE_GIFT_ITEM: `${giftCatalogPrefix}/update-gift-items`,
    PLACE_ORDER_POINTS: `/api/v1/crm-points/order/place-orde-v2`,
    GET_ORDERS: `${crmPointPrefix}/order/order-history`,
    GET_DASHOBARD_COUNTS: `${crmPointPrefix}/order/get-redeemption-dashboard`,
    GET_ADDRESS: `${crmPointPrefix}/get-address`,
    ADD_UPDATE_ADDRESS: `${crmPointPrefix}/add-update-address`,
    PLACE_ORDER: `${crmPointPrefix}/order/place-order`,
    GET_ORDERS_BY_FILTER: `${crmPointPrefix}/order/orders`,
    USER_UPDATE_DETAIL: `${crmPointPrefix}/update-user-detail`,
  },
  WARRANTY_REGISTRATION: {
    // GETVEHICLETYPE: "/api/v1/warranty/vehicle/get-vehicle-type",
    EVENT_REGISTRATION: "/api/v1/user/user-registration-event",
    GETVEHICLETYPE: "/api/v2/warranty/vehicle/get-vehicle-type",
    GETSTATE: "/api/v1/warranty/state-city/get-state",
    GETCITY: "/api/v1/warranty/state-city/get-state-city",
    GETSKUID: "/api/v1/warranty/vehicle/get-vehicle-sku-id",
    GET_TOP_SKU: "/api/v1/warranty/vehicle/get-vehicle-top-sku-id",
    GET_VEHICALE_MAKE: "/api/v1/warranty/vehicle/get-vehicle-type-brand",
    GET_VEHICALE_MODEL: "/api/v1/warranty/vehicle/get-vehicle-type-brand-model",
    GET_VEHICALE_VARIATION:
      "/api/v1/warranty/vehicle/get-vehicle-type-brand-model-variation",
    GET_CUSTOMER: "/api/v1/warranty/secondary-points/find-customer",
    POST_WARRANTY_REGISTRATION:
      "/api/v2/warranty/secondary-points/registration",
    POST_WARRANTY_REGISTRATION_V3:
      "/api/v3/warranty/secondary-points/registration",
    GENERATE_OTP: "/api/v2/warranty/secondary-points/send-otp",
    VERIFY_OTP: "/api/v2/warranty/secondary-points/verify-otp",
    WARRANTY_REPORT: "/api/v1/warranty/claim/warranty-report",
    WARRANTY_SUMMARY_REPORT:
      "/api/v1/warranty/secondary-points/warranty-summary-report",
    WARRANTY_REPORT_CHART:
      "/api/v1/warranty/secondary-points/get-warranty-chart",
  },
  MERCHANDISE_WALLET: {
    GET_ITEMS: "/api/v1/merchandise/dashboard/get-items",
    GET_DASHOBARD_COUNTS: "/api/v1/merchandise/dashboard/get-dashboard-coins",
    GET_ADDRESS: "/api/v1/merchandise/order/get-dealer-placed-address",
    PLACE_ORDER: "/api/v1/merchandise/order/place-order",
    GET_ORDERS: "/api/v1/merchandise/order/get-dealer-placed-orders",
    SEND_OTP_REDEMPTION:
      "/api/v2/warranty/secondary-points/send-otp-redemption",
    VERIFY_OTP_REDEMPTION:
      "/api/v2/warranty/secondary-points/verify-otp-redemption",
  },
  CIP_INTRACTION: {
    // Same as jk Adv
    GET_CIP_CATEGORY: "/api/v2/cip-register/get-cip-category",
    GET_INVITE_CLASSIFICATION:
      "/api/v2/cip-register/get-invitee-classification",
    GET_ACTIVITY: "/api/v2/cip-register/get-activity",
    GET_BRAND: "/api/v1/cip-register/get-brand",
    GET_BRAND_PATTERN: "/api/v1/cip-register/get-brand-pattern",
    GET_TRUCK_APM: "/api/v2/cip-register/get-truck-apm",

    // Path change
    ADD_CIP_V2: "/api/v1/baadshah/cip-register/add-cip",
    GET_CIP_V2: "/api/v1/baadshah/cip-register/get-cip",
    ADD_CIP_DETAILS_V2: "/api/v1/baadshah/cip-register/add-cip-details",
    GET_CIP_DETAIL: "/api/v1/baadshah/cip-register/get-cip-detail",
    GET_CIP_SUMMARY: "/api/v1/baadshah/cip-register/get-cip-detail-summary",
    DELETE_CIP_DEATIL: "/api/v1/baadshah/cip-register/delete-cip-detail",
    UPDATE_CIP_DETAIL_V2: "/api/v1/baadshah/cip-register/update-cip-detail",
    ADD_CO_ATTENDEE: "/api/v1/baadshah/cip-register/add-co-attendee",
    UPDATE_CO_ATTENDEE: "/api/v1/baadshah/cip-register/update-co-attendee",
    GET_CIP_CO_ATTENDEE_SUMMARY: "/api/v1/baadshah/cip-register/get-co-attendee-list",
    DELETE_CIP_CO_ATTENDEE: "/api/v1/baadshah/cip-register/delete-co-attendee",
    CANCEL_CIP: "/api/v1/baadshah/cip-register/cancel-cip",
    END_CIP: "/api/v1/baadshah/cip-register/end-cip",
    SEND_BILL_SETTLMENT: "/api/v1/baadshah/cip-register/send-summary-for-bill-settlement",

    // No change
    ADD_CIP: "/api/v1/cip-register/add-cip",
    GET_CIP: "/api/v1/cip-register/get-cip",
    ADD_CIP_DETAILS: "/api/v1/cip-register/add-cip-details",
    GET_CIP_DETAIL_SUMMARY: "/api/v1/cip-register/get-cip-detail-summary",
    UPDATE_CIP_DETAIL: "/api/v1/cip-register/update-cip-detail",
    DOWNLOAD_SUMMARY: "/api/v1/cip-register/download-summary",
  },
};
